import { defineAsyncComponent } from 'vue'
export default {
  "admin-kit": defineAsyncComponent(() => import("/app/layouts/admin-kit.vue")),
  admin: defineAsyncComponent(() => import("/app/layouts/admin.vue")),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue")),
  paimant: defineAsyncComponent(() => import("/app/layouts/paimant.vue")),
  "svg-sprite": defineAsyncComponent(() => import("#build/svg-sprite.vue"))
}